export default function userPasswords() {
	var captchaCount = 0;
	window.onloadCallback = onloadCallback;

	function onloadCallback() {
		var api_key = crb_site_ajax.gr_key;

		if ($('#forgot_id_recaptcha').length > 0) {
			var widget_id = grecaptcha.render('forgot_id_recaptcha', {
				'sitekey' : api_key
			});

			captchaCount++;
		}

		if ($('#forgot_pass_recaptcha').length > 0) {
			var widget_id = grecaptcha.render('forgot_pass_recaptcha', {
				'sitekey' : api_key
			});

			captchaCount++;
		}

		if ($('#reset_pass_recaptcha').length > 0) {
			var widget_id = grecaptcha.render('reset_pass_recaptcha', {
				'sitekey' : api_key
			});

			captchaCount++;
		}

		
	};

	$('.section-forgot-id form').on( 'submit', function(e){
		e.preventDefault();

		var $form = $(this);
		var $ajaxContainer = $('.section-forgot-id' );
		$.ajax({
			url: crb_site_ajax.ajaxurl,
			method: 'POST',
			data: {
				action: 'crb_forgot_id',
				email: $form.find('#field-email-business-id').val(),
				recaptcha: $form.find('.g-recaptcha-response').val(),
			},
			beforeSend() {
				$ajaxContainer.addClass('ajax-loading');
			},
			success: function( response ) {
				$ajaxContainer.removeClass('ajax-loading');

				var result = $.parseJSON( response );
				var messageContainer = '<div class="form__row"><span class="form__message">' + result.html + '</span></div>';

				
				if ( result.status === 'error' ) {
					resetCaptchas();
				} else {
					$form.find('.form__head').remove();
					$form.find('.form__body .form__row').remove();
					$form.find('.form__actions').remove();
				}

				if ($form.find('.form__message').length > 0 ) {
					$form.find('.form__message').html( messageContainer );
				} else {
					$form.find('.form__body').prepend( messageContainer );
				}
			},
			error() {
				$ajaxContainer.html('<h3>Error has occurred please try again!</h3>');
				$ajaxContainer.removeClass('ajax-loading');
			},
			always() {
				$ajaxContainer.removeClass('ajax-loading');
			}
		});
	});

	$('.section-forgot-pass form').on( 'submit', function(e){
		e.preventDefault();

		var $form = $(this);
		var $ajaxContainer = $('.section-forgot-pass' );
		$.ajax({
			url: crb_site_ajax.ajaxurl,
			method: 'POST',
			data: {
				action: 'crb_forgot_pass',
				username: $form.find('#field-username').val(),
				email: $form.find('#field-email').val(),
				recaptcha: $form.find('.g-recaptcha-response').val(),
			},
			beforeSend() {
				$ajaxContainer.addClass('ajax-loading');
			},
			success: function( response ) {
				$ajaxContainer.removeClass('ajax-loading');

				var result = $.parseJSON( response );
				var messageContainer = '<div class="form__row"><span class="form__message">' + result.html + '</span></div>';
				
				if ( result.status === 'error' ) {
					resetCaptchas();
				} else {
					$form.find('.form__head').remove();
					$form.find('.form__body .form__row').remove();
					$form.find('.form__actions').remove();
				}

				if ($form.find('.form__message').length > 0 ) {
					$form.find('.form__message').html( messageContainer );
				} else {
					$form.find('.form__body').prepend( messageContainer );
				}
			},
			error() {
				$ajaxContainer.html('<h3>Error has occurred please try again!</h3>');
				$ajaxContainer.removeClass('ajax-loading');
			},
			always() {
				$ajaxContainer.removeClass('ajax-loading');
			}
		});
	});

	$('.section-reset-account form').on( 'submit', function(e){
		e.preventDefault();

		var $form = $(this);
		var $ajaxContainer = $('.section-reset-account' );
		$.ajax({
			url: crb_site_ajax.ajaxurl,
			method: 'POST',
			data: {
				action: 'crb_reset_pass',
				username: $form.find('#field-username-reset').val(),
				password: $form.find('#field-pass-reset').val(),
				confirm: $form.find('#field-pass-conf-reset').val(),
				token: $form.find('#field-token').val(),
				recaptcha: $form.find('.g-recaptcha-response').val(),
			},
			beforeSend() {
				$ajaxContainer.addClass('ajax-loading');
			},
			success: function( response ) {
				$ajaxContainer.removeClass('ajax-loading');

				var result = $.parseJSON( response );
				var messageContainer = '<div class="form__row"><span class="form__message">' + result.html + '</span></div>';

				if ( result.status === 'error' ) {
					resetCaptchas();
				} else {
					$form.find('.form__head').remove();
					$form.find('.form__body .form__row').remove();
					$form.find('.form__actions').remove();
				}

				if ($form.find('.form__message').length > 0 ) {
					$form.find('.form__message').html( messageContainer );
				} else {
					$form.find('.form__body').prepend( messageContainer );
				}
			},
			error() {
				$ajaxContainer.html('<h3>Error has occurred please try again!</h3>');
				$ajaxContainer.removeClass('ajax-loading');
			},
			always() {
				$ajaxContainer.removeClass('ajax-loading');
			}
		});
	});

	$(".section-forgot-webex-pass form").on("submit", function (e) {
        e.preventDefault();

        var $form = $(this);
        var $ajaxContainer = $(".section-forgot-webex-pass");
        $.ajax({
            url: crb_site_ajax.ajaxurl,
            method: "POST",
            data: {
                action: "crb_forgot_webex_pass",
                username: $form.find("#field-username").val(),
                email: $form.find("#field-email").val(),
                recaptcha: $form.find(".g-recaptcha-response").val(),
            },
            beforeSend() {
                $ajaxContainer.addClass("ajax-loading");
            },
            success: function (response) {
                $ajaxContainer.removeClass("ajax-loading");

                var result = $.parseJSON(response);
                var messageContainer =
                    '<div class="form__row"><span class="form__message">' +
                    result.html +
                    "</span></div>";

                if (result.status === "error") {
                    resetCaptchas();
                } else {
                    $form.find(".form__head").remove();
                    $form.find(".form__body .form__row").remove();
                    $form.find(".form__actions").remove();
                }

                if ($form.find(".form__message").length > 0) {
                    $form.find(".form__message").html(messageContainer);
                } else {
                    $form.find(".form__body").prepend(messageContainer);
                }
            },
            error() {
                $ajaxContainer.html(
                    "<h3>Error has occurred please try again!</h3>"
                );
                $ajaxContainer.removeClass("ajax-loading");
            },
            always() {
                $ajaxContainer.removeClass("ajax-loading");
            },
        });
    });

    $(".section-reset-webex-account form").on("submit", function (e) {
        e.preventDefault();

        var $form = $(this);
        var $ajaxContainer = $(".section-reset-webex-account");
        $.ajax({
            url: crb_site_ajax.ajaxurl,
            method: "POST",
            data: {
                action: "crb_reset_webex_pass",
                username: $form.find("#field-username-reset").val(),
                password: $form.find("#field-pass-reset").val(),
                confirm: $form.find("#field-pass-conf-reset").val(),
                token: $form.find("#field-token").val(),
                recaptcha: $form.find(".g-recaptcha-response").val(),
            },
            beforeSend() {
                $ajaxContainer.addClass("ajax-loading");
            },
            success: function (response) {
                $ajaxContainer.removeClass("ajax-loading");

                var result = $.parseJSON(response);
                var messageContainer =
                    '<div class="form__row"><span class="form__message">' +
                    result.html +
                    "</span></div>";

                if (result.status === "error") {
                    resetCaptchas();
                } else {
                    $form.find(".form__head").remove();
                    $form.find(".form__body .form__row").remove();
                    $form.find(".form__actions").remove();
                }

                if ($form.find(".form__message").length > 0) {
                    $form.find(".form__message").html(messageContainer);
                } else {
                    $form.find(".form__body").prepend(messageContainer);
                }
            },
            error() {
                $ajaxContainer.html(
                    "<h3>Error has occurred please try again!</h3>"
                );
                $ajaxContainer.removeClass("ajax-loading");
            },
            always() {
                $ajaxContainer.removeClass("ajax-loading");
            },
        });
    });


	function resetCaptchas(){
		for (var i = 0; i < captchaCount; i++) {
			grecaptcha.reset( i );
		}
	}
}